import React from "react";
import './classes/PendingAthletes.css';
import { Helmet } from 'react-helmet';
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
import {  useNavigate,useLocation  } from 'react-router-dom';
import { useParams } from 'react-router-dom';
 import Loading from './Loading';


const Pendingathletes = () => {

  
    const [rows, setRows] = React.useState([]);
      const [rowCount, setRowCount] = React.useState(0);
      const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 30 });
      const [sortModel, setSortModel] = React.useState([]);
      const [filterModel, setFilterModel] = React.useState({ items: [] });
      const [isLoading, setIsLoading] = useState(true);
      const [showConfirmDialog, setShowConfirmDialog] = useState(false);
      const [athleteid, setAthleteId] = useState('');
      const[error,setError] = useState('');
      const[message,setMessage] = useState([]);
      const location  = useLocation();
      const Message = location.state?.message; 
      
        const[success,setSuccess] = useState('');
    const app_url = configData.APP_URL;
    const {id} = useParams();
    const loggedin_uid = localStorage.getItem('uid');

    useEffect(() => {
      if (Message) {
        setSuccess(Message);
        window.history.replaceState({}, '');
      }
    }, [Message, location.state]);

const columns = [
   {
    field: 'name',
     headerName: 'Name',
    headerClassName: 'super-app-theme--header',
   flex:1,
   sortable: false,
    filterable: false,
     renderCell: (params) => (
          <Link href={params.row.name_link} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.name || ''}
          </Link>
        ),
  },
   {
    field: 'sport',
    headerName: 'Sport',
    headerClassName: 'super-app-theme--header',
    flex:1, 
    sortable: false,
    filterable: false,    
    
  },
   {
    field: 'location',
    headerName: 'Location',
    headerClassName: 'super-app-theme--header',
    flex:1,     
    sortable: false,
    filterable: false,
  },
   {
    field: 'age',
    headerName: 'Age',
    headerClassName: 'super-app-theme--header',
        flex:1,     
   sortable: false,
    filterable: false, 
  },
  {
    field: 'school',
    headerName: 'School',
    headerClassName: 'super-app-theme--header',
     flex:1,     
    sortable: false,
    filterable: false,
  },
  {
    field: 'position',
    headerName: 'Position',
    headerClassName: 'super-app-theme--header',
        flex:1,     
    sortable: false,
    filterable: false,
  },
  {
    field: 'height',
    headerName: 'Height',
    headerClassName: 'super-app-theme--header',
         flex:1,     
    sortable: false,
    filterable: false,
  },
  {
    field: 'weight',
    headerName: 'Weight',
    headerClassName: 'super-app-theme--header',
      flex:1,     
    sortable: false,
    filterable: false,
  },
  {
    field: 'high_school',
    headerName: 'High School',
    headerClassName: 'super-app-theme--header',
         flex:1,     
    sortable: false,
    filterable: false,
  },
  {
    field: 'high_school_city_and_state',
    headerName: 'High School City & State',
    headerClassName: 'super-app-theme--header',
     flex:1,     
   sortable: false,
    filterable: false, 
  },
  {
    field: 'UAA.field_tier_status_date',
    headerName: 'Available Since',
    headerClassName: 'super-app-theme--header',
     cellClassName: 'available-since',
    flex:1, 
    minWidth:125,
          sortable: true,
    filterable: false,
      renderHeader: () => (
    <div style={{ display: 'flex', alignItems: 'center', color: '#2C99D2',fontWeight:'bold',width:'70px' }}>
          <span>Available Since</span>
    
    </div>
  )
   
  },
  
  {
    field: 'represent_athlete',
    headerName: 'Represent Athlete',
    headerClassName: 'super-app-theme--header',
        sortable: false,
      flex:1, 
      renderCell: (params) => (
        <><img  style={{cursor: "pointer" }} onClick={() => handleApprovalClick(params.row.drupal_uid)} className="approval_image"  src="/basic/web/images/approve.gif" alt="Approve" border="0" align="top" /></>
          )
    
  },
];
      useEffect(() => {
              Promise.all([
                  checkpermissionforpageaccess()
              ])
              .then(() => {
           
              setIsLoading(false);
              })
           
          },[]);
           async function checkpermissionforpageaccess() {
    
       
            const response = await fetch(
                 app_url+'smwwagency/checkpermissionforotherpageaccess?uid='+loggedin_uid,
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                
            } 
             if(responsedata.data.msg === "Error") {
                setMessage(responsedata.data.result);
            } 

       
    }
    const fetchData = async () => {
            // Simulate API call to your server
            // In a real application, replace this with your actual fetch logic
            try {
               setIsLoading(true);
            const response = await fetch(app_url+'smwwathlete/getpendingathletedetails', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
                sortModel,
                filterModel,
                id:id
              }),
            });
            const data = await response.json();
            console.log(data.data.rows);
            setRows(data.data.rows);
            setRowCount(data.data.totalRowCount); // Server should return totalRowCount
          }  catch (error) {
                  console.error('Error fetching data:', error);
                } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                }
          };
        React.useEffect(() => {
           
          
      
          fetchData();
        }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change

         const handleApprovalClick = (drupal_athlete_id) => {
          setShowConfirmDialog(true);
          setAthleteId(drupal_athlete_id);
        };
        const handleConfirm = async () => {
      setShowConfirmDialog(false);
      try {
        const response = await fetch(
                app_url+'smwwathlete/acceptathlete',
                {
                    method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                athleteid: athleteid,
                loggedin_id: localStorage.getItem('drupal_uid')
                
              }),
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
              alert(responsedata.data.result);
              
              setSuccess(responsedata.data.result);
              fetchData();
              setError('');
              window.scrollTo(0, 0);
            }
             if(responsedata.data.msg == "Error") {
              alert(responsedata.data.result);
              setError(responsedata.data.result);
              setSuccess('');

            }
      } catch (error) {
        console.error('API call failed:', error);
      }
    };
     const handleCancel = () => {
      setShowConfirmDialog(false);
    };
    return(
      <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main" className="pending-athlete-main">
          <Helmet><title>Athletes Looking for an agent</title></Helmet>
           
             <div class="center left-center">
              {message.length > 0 ? (
                <div>
                  {message.map((item, index) => {
                    return <><div dangerouslySetInnerHTML={{ __html: item }} /><br /></>
          
                  })}  
                </div>
              ) : (
                <div className="pending-athlete-container">
                    <h1>Athletes Looking for an Agent</h1>
                    {error && (
                    <div className="set-message-error">
                    {error}
                    </div>
          
                     )}  
          
        
       {success && (
          <div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {success}
          </div>
          
       
        )}
                    {showConfirmDialog && (
       <div className="dialog-overlay">
          <div className="dialog-content">
            <h2>Confirmation</h2>
            <p>By agreeing to represent this athlete, you agree to incur any expenses at your own risk.<br/>
You also agree to split your commission with SMWW as defined in our contractual agreement.<br/>
Click OK to continue and confirm your decision to represent this athlete.</p>
            <div className="dialog-actions">
              <button onClick={handleConfirm}>Confirm</button>
              <button onClick={handleCancel}>Cancel</button>
            </div>
          </div>
        </div>
    )}
                    <div className="pending-athlete-short-link">
                        <a href="/pending_athletes/45">Action Sports</a>
                        |<a href="/pending_athletes/2">Baseball</a>
                        |<a href="/pending_athletes/3">Basketball</a>
                        |<a href="/pending_athletes/7">Boxing</a>
                        |<a href="/pending_athletes/8">Cricket</a>
                        |<a href="/pending_athletes/9">Curling</a>
                        |<a href="/pending_athletes/42">Extreme Sports</a>
                        |<a href="/pending_athletes/1">Football (American)</a>
                        |<a href="/pending_athletes/5">Golf</a>
                        |<a href="/pending_athletes/6">Hockey</a>
                        |<a href="/pending_athletes/15">Racing</a>
                        |<a href="/pending_athletes/44">Olympic</a>
                        |<a href="/pending_athletes/41">Other</a>
                        |<a href="/pending_athletes/16">Polo</a>
                        |<a href="/pending_athletes/18">Rodeo</a>
                        |<a href="/pending_athletes/46">Rugby</a>
                        |<a href="/pending_athletes/4">Soccer</a>
                        
                        |<a href="/pending_athletes/30">Tennis</a>
                        |<a href="/pending_athletes/31">Track and Field</a></div>
                
                 <div className="pending-athlete-table" style={{ width: '100%'}}>    
                     <DataGrid
                                                        autoHeight ={true}
                                                        rows={rows}
                                                        columns={columns}
                                                         headerHeight={80}
                                                        rowCount={rowCount}
                                                        paginationMode="server"
                                                        sortingMode="server"
                                                        filterMode="server"
                                                        paginationModel={paginationModel}
                                                        onPaginationModelChange={setPaginationModel}
                                                        sortModel={sortModel}
                                                        onSortModelChange={setSortModel}
                                                         filterModel={filterModel}
                                                        onFilterModelChange={setFilterModel}
                                                        pageSizeOptions={[5, 10, 25,50]}
                                                        getRowId={() => crypto.randomUUID()}
                                                        getRowHeight={() => 'auto'}
                                                        disableColumnFilter 
                                                        disableColumnResize={false}
                                                         //  hideScrollbar={true}                                         
                            sx={{fontFamily: '"Open Sans", sans-serif, Arial, Verdana','& .MuiDataGrid-row': { marginTop: 1, marginBottom: 1 }, 
                                    '& .coloured': { textAlign: 'center', color: '#7181AD' },
                                    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {display: 'block' },
                                 '& .super-app-theme--header': { fontSize: '14px'},
                                  '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold !important',   textOverflow: "clip",
                whiteSpace: "break-spaces",
                lineHeight: 1},
                                '& .MuiDataGrid-cell': {
                                                        whiteSpace: 'normal',
                                                        wordWrap: 'break-word',
                                                        lineHeight: '1.4',
                                                        alignItems: 'center', 
                                                        display: 'flex',
                                                        },
          
                             

                                    // '& .MuiTablePagination-actions': {
                                    // marginRight: 10,
                                    // },
                                    

                                }}
                                                        
                                                    />
                 </div>
                 </div>
                 )}
             </div>
        </div>
        )}
    </>
    );
    };

export default Pendingathletes;